export default __webpack_public_path__ + "navigation-overview-setup-ib-1200-b039cc91414157a5020e4b08ff98374c.png";